module.exports = __webpack_public_path__ + "e55ddf17f4632c0440efdac22cff5365.svg";